import { PowerUpsContainer } from "./PowerUpsContainer";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { GameManager } from "../GameManager";

export class PowerUp extends Phaser.Group {

    public powerUpsContainer: PowerUpsContainer;

    private powerUpType: string;
    private price: number;
    private purchased: boolean;
    private readyForUseImage: Phaser.Image;
    private noMoneyImage: Phaser.Image;
    private buyButton: Phaser.Button;
    private coinImage: Phaser.Image;
    private isBuyButtonActivated: boolean;
    private priceLabel: Phaser.Text;

    constructor(game: Phaser.Game, powerUpType: string) {

        super(game, null, "powerup-container-" + powerUpType, false);

        this.powerUpType = powerUpType;
        this.isBuyButtonActivated = true;

        var powerUpImageName: string;

        switch (this.powerUpType) {

            case GameConstants.FREEZE_GOALKEEPER:
                powerUpImageName = "shop_freeze-goalkeeper";
                this.price = GameConstants.FREEZE_GOALKEEPER_PRICE;
                this.purchased = GameVars.gameData.powerUpState.freezeGoalkeeperPurchased;
                break;
            case GameConstants.EXTRA_BALLS:
                powerUpImageName = "shop_extra_balls";
                this.price = GameConstants.EXTRA_BALLS_PRICE;
                this.purchased = GameVars.gameData.powerUpState.extraBallsPurchased;
                break;
            case GameConstants.BALL_OF_FIRE:
                powerUpImageName = "shop_ball_of_fire";
                this.price = GameConstants.BALL_OF_FIRE_PRICE;
                this.purchased = GameVars.gameData.powerUpState.ballOfFirePurchased;
                break;
            case GameConstants.VOODOO:
                powerUpImageName = "shop_voodoo";
                this.price = GameConstants.VOODOO_PRICE;
                this.purchased = GameVars.gameData.powerUpState.voodooPurchased;
                break;
            default:
        }

        let powerUpImage = new Phaser.Image(this.game, 15, 15, "texture_atlas_5", powerUpImageName);
        this.add(powerUpImage);

        // la etiqueta con el precio
        let priceString: string = GameVars.formatNumber(this.price);
        this.priceLabel = new Phaser.Text(this.game, 80, 107,
            priceString, { font: "32px Ubuntu", fontWeight: "700", fill: "#FFD51B", align: "center" });
        this.priceLabel.x -= this.priceLabel.width / 2;
        this.add(this.priceLabel);

        this.coinImage = new Phaser.Image(this.game, 140, 109, "texture_atlas_5", "coin");
        this.coinImage.visible = false;
        this.add(this.coinImage);

        // la imagen de que no hay dinero
        this.noMoneyImage = new Phaser.Image(this.game, 15, 15, "texture_atlas_5", "powerup_no_money");
        this.noMoneyImage.visible = false;
        this.add(this.noMoneyImage);

        // la imagen de ready for use
        this.readyForUseImage = new Phaser.Image(this.game, -2, -2, "texture_atlas_5", "powerup_ready");
        this.readyForUseImage.visible = false;
        this.add(this.readyForUseImage);

        // el boton de buy
        this.buyButton = new Phaser.Button(this.game, 0, -15, "texture_atlas_5", this.onClickBuyButton, this, 1, 0, 1);
        this.buyButton.setFrames("powerup_buy_button_on", "powerup_buy_button_off", "powerup_buy_button_on", "powerup_buy_button_off");
        this.buyButton.visible = false;
        this.add(this.buyButton);

        if (!this.purchased) {

            this.priceLabel.visible = true;
            this.coinImage.visible = true;

            if (GameVars.gameData.credits < this.price) {

                this.noMoneyImage.visible = true;

                this.buyButton.visible = true;
                this.buyButton.alpha = .45;
                this.isBuyButtonActivated = false;

            } else {

                this.buyButton.visible = true;
                this.isBuyButtonActivated = true;
            }

        } else {

            this.readyForUseImage.visible = true;
        }
    }

    public updatePowerUp(): void {

        switch (this.powerUpType) {
            case GameConstants.FREEZE_GOALKEEPER:
                this.purchased = GameVars.gameData.powerUpState.freezeGoalkeeperPurchased;
                break;
            case GameConstants.EXTRA_BALLS:
                this.purchased = GameVars.gameData.powerUpState.extraBallsPurchased;
                break;
            case GameConstants.BALL_OF_FIRE:
                this.purchased = GameVars.gameData.powerUpState.ballOfFirePurchased;
                break;
            case GameConstants.VOODOO:
                this.purchased = GameVars.gameData.powerUpState.voodooPurchased;
                break;
            default:
        }

        if (!this.purchased) {

            if (GameVars.gameData.credits < this.price) {

                this.noMoneyImage.visible = true;

                this.buyButton.visible = true;
                this.buyButton.alpha = .45;
                this.isBuyButtonActivated = false;

            } else {
                this.noMoneyImage.visible = false;

                this.buyButton.visible = true;
                this.buyButton.alpha = 1;
                this.isBuyButtonActivated = true;
            }

            this.readyForUseImage.visible = false;
            this.priceLabel.visible = true;
            this.coinImage.visible = true;

        } else {

            this.purchased = false;
            this.buyButton.visible = false;
            this.isBuyButtonActivated = false;
            this.readyForUseImage.visible = true;
            this.priceLabel.visible = false;
            this.coinImage.visible = false;
        }
    }

    private onClickBuyButton(): void {

        if (!this.isBuyButtonActivated) {
            return;
        }

        // informar al GameManager
        GameManager.onPowerUpPurchased(this.powerUpType);

        this.purchased = false;
        this.buyButton.visible = false;
        this.isBuyButtonActivated = false;
        this.readyForUseImage.visible = true;
        this.priceLabel.visible = false;
        this.coinImage.visible = false;

        this.powerUpsContainer.updateContainer();
    }
}
